import { AUDIO_NAME_PREFIX, IMAGE_NAME_PREFIX, SITE, VIDEO_NAME_PREFIX } from '@/app/constants';
import type { ReferencePrompt, SupportedLanguage } from '@/app/types';

// 根据语言获取图片名称前缀
export const getImagePrefix = (locale: SupportedLanguage) => {
  return IMAGE_NAME_PREFIX[SITE][locale] ?? '';
};

export const getVideoPrefix = (locale: SupportedLanguage) => {
  return VIDEO_NAME_PREFIX[SITE][locale] ?? 'video';
};

export const getAudioPrefix = (locale: SupportedLanguage) => {
  return AUDIO_NAME_PREFIX[SITE][locale] ?? 'audio';
};

// 生成下一个图片名称
export const getNextImageName = (currentIdx: number, locale: SupportedLanguage) => {
  const prefix = getImagePrefix(locale);
  return `${prefix}${currentIdx}`;
};

// 查找下一个可用的图片索引（从1开始）
export const getNextAvailableImageIdx = (referencePrompts: ReferencePrompt[], locale: SupportedLanguage) => {
  const imagePrompts = referencePrompts.filter((prompt) => prompt.type === 'image');
  const prefix = getImagePrefix(locale);
  const regExp = new RegExp(`^${prefix}(\\d+)$`);

  // 创建一个集合，保存当前使用的索引
  const usedIndices = new Set<number>();

  imagePrompts.forEach((prompt) => {
    if (prompt.name && regExp.test(prompt.name)) {
      const numStr = prompt.name.replace(prefix, '');
      const num = Number.parseInt(numStr, 10);
      if (!Number.isNaN(num)) {
        usedIndices.add(num);
      }
    }
  });

  // 从1开始查找第一个未使用的索引
  let idx = 1;
  while (usedIndices.has(idx)) {
    idx++;
  }

  return idx;
};

// 生成下一个视频名称
export const getNextVideoName = (currentIdx: number, locale: SupportedLanguage) => {
  const prefix = getVideoPrefix(locale);
  return `${prefix}${currentIdx}`;
};

// 视频逻辑比较简单，通常只有1-2个，所以直接返回视频数量+1
export const getNextAvailableVideoIdx = (referencePrompts: ReferencePrompt[]) => {
  const videoPromptsCount = referencePrompts.filter((prompt) => prompt.type === 'video').length;
  return videoPromptsCount + 1;
};

export const getNextAudioName = (currentIdx: number, locale: SupportedLanguage) => {
  const prefix = getAudioPrefix(locale);
  return `${prefix}${currentIdx}`;
};

export const getNextAvailableAudioIdx = (referencePrompts: ReferencePrompt[], locale: SupportedLanguage) => {
  const audioPrompts = referencePrompts.filter((prompt) => prompt.type === 'audio');
  const prefix = getAudioPrefix(locale);
  const regExp = new RegExp(`^${prefix}(\\d+)$`);
  const usedIndices = new Set<number>();

  audioPrompts.forEach((prompt) => {
    if (prompt.name && regExp.test(prompt.name)) {
      const numStr = prompt.name.replace(prefix, '');
      const num = Number.parseInt(numStr, 10);
      if (!Number.isNaN(num)) {
        usedIndices.add(num);
      }
    }
  });

  let idx = 1;
  while (usedIndices.has(idx)) {
    idx++;
  }

  return idx;
};
